import { useMemo } from 'react';
import { useModulesContext } from '../context/ModulesContext.js';
/**
 * Returns whether the current user has access to the given module slug,
 * plus the matching instances (for badge/count display without a second hook call).
 * Drives the 403 empty-state in module routes (Phase 7).
 */
export function useModuleAccess(slug) {
    const { instances } = useModulesContext();
    return useMemo(() => {
        if (!slug)
            return { hasAccess: false, instances: [] };
        const matches = instances.filter((i) => i.slug === slug);
        return { hasAccess: matches.length > 0, instances: matches };
    }, [instances, slug]);
}
//# sourceMappingURL=useModuleAccess.js.map